<template>
    <v-container class="pa-16">
      <v-data-table
        :headers="headers"
        :items="dossiers"
        class="elevation-0 myTable"
        :options.sync="options"
        :server-items-length="total"
        :footer-props="{
          itemsPerPageOptions: [20, 30, 40, 50],
          showFirstLastPage: true,
          itemsPerPageText: 'Lignes par page :',
        }"
        :header-props="{ sortIcon: null }"
        no-data-text=""
        no-results-text=""
      >
        <template v-slot:body.prepend v-if="loader">
          <tr v-for="n in 5" :key="'skeleton-' + n">
            <td :colspan="headers.length + 1">
              <v-skeleton-loader type="table-row" class="mx-5 my-2" />
            </td>
          </tr>
        </template>
        <template v-slot:no-data v-if="!loader">
          Aucun projet
        </template>
        <template v-slot:top>
          <v-toolbar flat extended extension-height="100">
            <v-toolbar-title id="toolbar-title">Projets </v-toolbar-title>
            <text-input
              prepend-inner-icon="mdi-magnify"
              @keyup="handleSearch"
              class="ml-5 mt-5"
              id="search"
              v-model="filteredItem.name"
              placeholder="Nom du projet"
            />
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <v-icon v-if="item.status === 0" class="outlined inactive-status"
            >mdi-close</v-icon
          >
          <v-icon v-if="item.status === 1" class="outlined active-status"
            >mdi-check</v-icon
          >
          {{ item.name }}
        </template>
        <template v-slot:item.affectation="{ item }">
          <div :key="item.agent">
            <template v-for="i in item.affectation">
              <Avatar
                user="false"
                :item="i.agent"
                :key="i.agent?.id"
                style="margin-left:-10px"
              />
            </template>
          </div>
        </template>
      </v-data-table>
    </v-container>
  </template>
  <script>
  import {
    TextInput,
    Avatar,
  } from "@/components/base";
import { getListFolderByAgentId } from "../../../services/dossiers.api";
  export default {
    components: {TextInput,Avatar},
    data: () => ({
      loader: false,
      total: 0,
      options: {},
      text: "",
      items: [],
      headers: [
        {
          text: "Projet",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Client", value: "client.name" },
        { text: "Equipe", value: "affectation" },
        { text: "Heures estimées", value: "totEstimatedHours" },
        { text: "Heures consommées", value: "totConsumedHours" }
      ],
      dossiers: [],
      filteredItem: {},
      timeout: null,
      pageNumber: 1,
      last_page: 0,
    }),
    watch: {
      options: {
        handler() {
          this.loader = true;
          this.dossiers = [];
          this.pageNumber = this.options.page
          const perPage = this.options.itemsPerPage;
          getListFolderByAgentId(this.pageNumber,this.filteredItem, perPage).then((response) => {
            this.dossiers = response.data.data;
            for (let i in response.data.data) {
              let ids = this.dossiers[i].affectation.map((o) => o.user_id);
              this.dossiers[i].affectation = this.dossiers[i].affectation.filter(
                ({ user_id }, index) => !ids.includes(user_id, index + 1)
              );
            }
            this.last_page = response.data.last_page;
            this.total = response.data.total;
          })
          .finally(() => {
            this.loader = false;
          });
        },
        deep: true,
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      getProjects() {
        this.pageNumber = this.options.page
        const perPage = this.options.itemsPerPage
        this.loader = true;
        getListFolderByAgentId(this.pageNumber,this.filteredItem, perPage).then((response) => {
          this.dossiers = response.data.data;
          for (let i in response.data.data) {
            let ids = this.dossiers[i].affectation.map((o) => o.user_id);
            this.dossiers[i].affectation = this.dossiers[i].affectation.filter(
              ({ user_id }, index) => !ids.includes(user_id, index + 1)
            );
          }
          this.last_page = response.data.last_page;
          this.total = response.data.total;
        })
        .finally(() => {
          this.loader = false;
        });
      },
      handleSearch() {
        this.pageNumber = 1;
        if (this.filteredItem.name !== "") {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.getProjects();
          }, 1000);
        } else {
          this.getProjects();
        }
      },
      initialize() {
        this.getProjects();
      },
    },
  };
  </script>
  <style scoped>
  .myTable .datatable thead th.column.sortable i {
    display: none;
  }
  
  .v-icon.outlined {
    border: 1px solid currentColor;
    border-radius: 50%;
    padding: 3px;
  }
  </style>
  